export default {
  jurassic: {
    spino: {
      label: 'Spino',
      image: 'spino.png',
    },
    stego: {
      label: 'Stego',
      image: 'stego.png',
    },
    rex: {
      label: 'Rex',
      image: 'rex.png',
    },
    terra: {
      label: 'Terra',
      image: 'terra.png',
    },
  },
  fairytale: {
    princess: {
      label: 'Princess',
      image: 'princess.png',
    },
    jester: {
      label: 'Jester',
      image: 'jester.png',
    },
    prince: {
      label: 'Prince',
      image: 'prince.png',
    },
    fairy: {
      label: 'Fairy',
      image: 'fairy.png',
    },
  },
};